<p-panel>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <h5><img class="delete-icon" src="./assets/svgs/incoming.svg" />{{ 'summary-page.incoming-routes' | translate }}</h5>
    </div>
  </ng-template>
  <ng-template pTemplate="icons">
    <a href="" (click)="openAddEditRouteDialog(installation); false">{{ 'igrid-system-routings.add-incoming-route' | translate }} ➕</a>
  </ng-template>

  @if (allSystems$ | async; as systems) {
    <ng-container
      *ngTemplateOutlet="
        routingsTable;
        context: {
          routings: routings?.incoming,
          systems: systems,
          isIncoming: true
        }
      "
  ></ng-container>
} @else {
  <div class="loading-routes">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
</p-panel>


<p-panel>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <h5><img class="delete-icon" src="./assets/svgs/outgoing.svg" />{{ 'summary-page.outgoing-routes' | translate }}</h5>
    </div>
  </ng-template>
  @if (allSystems$ | async; as systems) {
    <ng-container
      *ngTemplateOutlet="
        routingsTable;
        context: {
          routings: routings?.outgoing,
          systems: systems,
          isIncoming: false
        }
      "
  ></ng-container>
} @else {
  <div class="loading-routes">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
</p-panel>

<ng-template #routingsTable let-routings="routings" let-systems="systems" let-isIncoming="isIncoming">
  @if (routings?.length) {
    <gbc-table>
      <tr gbc-table-row>
        <th gbc-table-header>{{ 'app-installation' | translate }}</th>
        <th>{{ 'igrid-system-routings.routing-name' | translate }}</th>
        <th>{{ 'igrid-system-routings.routing-enabled' | translate }}</th>
        <th>{{ 'igrid-system-routings.description' | translate }}</th>
        <th [attr.colspan]="isIncoming ? 1 : 2">{{ 'igrid-system-routings.strategy' | translate }}</th>
        @if (isIncoming) {
          <th class="actions">
            {{ 'igrid-system-routings.actions' | translate }}
          </th>
        }
      </tr>
      @for (route of routings; track route) {
        <tr class="route-row" gbc-table-row>
          @if (isIncoming) {
            @if (navigateRoutings && route.sourceDeviceId | generateLinkFromDeviceId: systems; as system) {
              <td gbc-table-cell>
                <ng-container *ngTemplateOutlet="linkFormat; context: { route: route.sourceDeviceId, system: system }"></ng-container>
              </td>
            } @else {
              <td class="route-text">{{ route.sourceDeviceId }}</td>
            }
          }
          @if (!isIncoming) {
            @if (navigateRoutings && route.targetDeviceId | generateLinkFromDeviceId: systems; as system) {
              <td class="no-left-padding" gbc-table-cell>
                <ng-container *ngTemplateOutlet="linkFormat; context: { route: route.targetDeviceId, system: system }"></ng-container>
              </td>
            } @else {
              <td class="route-text">{{ route.sourceDeviceId }}</td>
            }
          }
          <td>{{ route.routingName }}</td>
          <td><img class="route-enabled" [src]="route.enabled ? './assets/svgs/green-checked-circle.svg' : './assets/svgs/remove-circle_filled.svg'" /></td>
          <td>{{ route.description }}</td>
          <td [attr.colspan]="isIncoming ? 1 : 2">{{ route.strategy }}</td>
          @if (isIncoming) {
            <td class="actions-table-cell">
              <button (click)="openAddEditRouteDialog(installation, route)" gbc-icon-button>✏️ {{ 'app-edit' | translate }}</button>
              <button (click)="openDeleteRouteDialog(route)" gbc-icon-button>🗑️ {{ 'app-delete' | translate }}</button>
            </td>
          }
        </tr>
      }
    </gbc-table>
  } @else {
    <gbc-table>
      <tr class="no-routes-row no-bg" gbc-table-row>
        <td>
          {{ 'igrid-system-routings.no-routings-for-system' | translate }}
        </td>
      </tr>
    </gbc-table>
  }

</ng-template>


<ng-template #linkFormat let-route="route" let-system="system">
  <a class="route-link" href="" (click)="navigateToInstallation(system); (false)">{{ route }}</a>
</ng-template>
